export default "__VITE_ASSET__7e410e5c__"